module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/8daf4b4980075c7a212fb3e53ea3abf1.png";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/student-reports/certificates/new_certificates/gold.png
// module id = LL8+
// module chunks = 0